import api from './api';

const atelierApi = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.statut) params.append('statut', filters.statut);
    if (filters.type) params.append('type', filters.type);
    if (filters.search) params.append('search', filters.search);
    
    return api.get(`/atelier?${params.toString()}`);
  },

  getById: (id) => api.get(`/atelier/${id}`),

  create: (vehiculeData) => api.post('/atelier', vehiculeData),

  update: (id, vehiculeData) => api.put(`/atelier/${id}`, vehiculeData),

  delete: (id) => api.delete(`/atelier/${id}`),
  getArchives: () => api.get('/atelier/archives'),
  unarchive: (id) => api.put(`/atelier/${id}/unarchive`),

  getCommentaires: (vehiculeId) => api.get(`/atelier/${vehiculeId}/commentaires`),

  addCommentaire: (vehiculeId, commentaireData) => 
    api.post(`/atelier/${vehiculeId}/commentaires`, commentaireData),

  exportExcel: () => api.get('/atelier/export/excel'),

  importExcel: (rows) => api.post('/atelier/import', { rows })
};

export default atelierApi;